import styled from "@emotion/styled";
import { BlockState } from "../types";
import React from 'react';
import { MazeBlock } from "./MazeBlock";

interface MazeRowType {
    row: number[];
    row_index: number;
}
export const MazeRow: React.FC<MazeRowType> = ({ row, row_index }) => {
    const StyledRow = styled.div`
        width: 800px;
        height: 25px;
    `

    return (
        <StyledRow>
            {
                row.map((box, col_index) => {
                    return (<MazeBlock key={`mazeBlock${row_index}${col_index}`} blockState={box} />)
                })
            }
        </StyledRow>
    )



}